import { styled } from '@mui/material/styles';
import LogoSmall from './LogoSmall';

const RootStyle = styled('div')({
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export default function LoadableContentArea() {
  return (
    <RootStyle>
      <LogoSmall sx={{ width: 64, height: 64 }} />
    </RootStyle>
  );
}
